import React                                            from "react";
import { Checkbox }                                     from "@sirius/ui-lib/src/blocks/Controls";
import {UiSchemaEntry, DataCellType, ColumnCellType}    from "../@types";


const DataCell:React.FC<DataCellType> = ({row, checked, toggleRowChecked}) =>
    <Checkbox
        checked  = {checked}
        onChange = {()=>{toggleRowChecked(row)}}
    />
;

const ColumnCell:React.FC<ColumnCellType> = ({allChecked, toggleAllChecked}) =>
    <Checkbox
        checked  = {allChecked}
        onChange = {toggleAllChecked}
    />
;

const select: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {select}
